module.exports = __webpack_public_path__ + "img/reports-active.afc32623.svg";